export const UserStatus = {
  key: "user_status",
  value: {
    unRegister: "未登録",
    freeUser: "無料会員",
    subscriptionUser: "有料会員",
    schoolUser: "スクール会員",
  },
};

export const SubscribeStatus = {
  key: "subscribe_status",
  value: {
    none: "未課金",
    unSubscribe: "課金退会",
    subscribeMonth: "月額",
    subscribeYear: "年額",
  },
};

export const LoginStatus = {
  key: "login_status",
  value: {
    loggedIn: "ログイン済",
    loggedOut: "未ログイン",
  },
};
